<template>
	<div v-cloak>
		<div class="modal fade" id="modalEvent" role="dialog" aria-labelledby="modalEventLabel" aria-hidden="true">
		 	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
		   		<div class="modal-content">
		      		<div class="modal-header position-relative border-bottom border-danger" style="background-image: url('https://materializecss.com/images/office.jpg');color: white;">
						<h3 class="py-2">
							Agregar Evento
							
							<span class="position-absolute" style="right: 25px; bottom: -20px; z-index: 1;">
								<button type="button" class="btn btn-danger rounded-circle" style="width: 50px; height: 50px;" data-dismiss="modal" aria-label="Close">
									<i class="material-icons">close</i>
								</button>
							</span>
						</h3>
					</div>
		      		<div class="modal-body p-0">
		      			<div class="card">
						  	<div class="card-header p-0">
						    	<ul class="nav nav-tabs card-header-tabs m-0">
						      		<li class="nav-item">
						        		<a class="nav-link active" id="event-tab" data-toggle="tab" href="#event" role="tab" aria-controls="event" aria-selected="false">Evento</a>
						      		</li>
						      		<li class="nav-item">
						        		<a class="nav-link" id="invitado-tab" data-toggle="tab" href="#invitado" role="tab" aria-controls="invitado" aria-selected="false">Agregar Invitados</a>
						      		</li>
						    	</ul>
						  	</div>
						  	<div class="card-body">
						  		<div class="tab-content" id="myTabContent">
									<div class="tab-pane fade show active" id="event" role="tabpanel" aria-labelledby="event-tab">
										<div class="row">
											<div class="col-md-12 mb-2">
												<small class="mb-0">Título</small>
												<input type="text" class="form-control" v-model="forms.title" placeholder="Añadir Título">
							                    <div class="text-danger" v-if="errors.title">
					                            	{{ arrayText(errors.title) }}
					                            </div>
											</div>

											<div class="col-md-6 mb-2">
												<small class="mb-0">Oportunidad</small>
												<select2 class="form-control" v-model="forms.oportunidad" required>
							                        <option v-for="oportunidad in oportunidades" v-bind:value="oportunidad.CODIGO_OPORTUNIDAD">{{ oportunidad.DESCRIPCION_OPORTUNIDAD }}</option>
							                    </select2>
							                    <div class="text-danger" v-if="errors.oportunidad">
					                            	{{ arrayText(errors.oportunidad) }}
					                            </div>
											</div>

											<div class="col-md-6 mb-2">
												<small class="mb-0">Tipo</small>
												<select2 class="form-control" v-model="forms.tipo_tarea" required>
							                        <option data-icon="fa fa-phone-square mr-2 text-primary">Llamada</option>
							                        <option data-icon="fa fa-car mr-2 text-danger">Visita</option>
							                        <option data-icon="fa fa-envelope mr-2 text-secondary">Correo</option>
							                        <option data-icon="fab fa-whatsapp mr-2 text-success">WhatsApp</option>
							                        <option data-icon="fa fa-user mr-2 text-muted">Seguimiento a Cliente</option>
							                        <option data-icon="fa fa-cogs mr-2 text-dark">Soporte Interno</option>
							                    </select2>

							                    <div class="text-danger" v-if="errors.tipo_tarea">
					                            	{{ arrayText(errors.tipo_tarea) }}
					                            </div>
											</div>

											<div class="col-md-6 mb-2">
												<small class="mb-0">Fecha Inicial:</small>
							                    <date-picker name="fecha_inicial" v-model="forms.fecha_inicial" placeholder="Fecha Inicial" required></date-picker>
							                    <div class="text-danger" v-if="errors.fecha_inicial">
					                            	{{ arrayText(errors.fecha_inicial) }}
					                            </div>
											</div>

											<div class="col-md-6 mb-2">
												<small class="mb-0">Fecha Final:</small>
												<date-picker name="fecha_final" v-model="forms.fecha_final" placeholder="Fecha Final" required></date-picker>
							                    <div class="text-danger" v-if="errors.fecha_final">
					                            	{{ arrayText(errors.fecha_final) }}
					                            </div>
											</div>

											<div class="col-md-12 mb-2">
												<small class="mb-0">Notas:</small>
							                    <textarea class="form-control" v-model="forms.notas" data-type="string" placeholder="Notas" maxlength="250" required></textarea>
							                    <div class="text-danger" v-if="errors.notas">
					                            	{{ arrayText(errors.notas) }}
					                            </div>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="invitado" role="tabpanel" aria-labelledby="invitado-tab">
										<div class="row">
											<div class="col-md-12 mb-2" v-if="!loading.emails">
												<small class="mb-0">Agregar los correos de las personas:</small>
							                    <autocomplete id="select-to" v-model="forms.emails" :emails="emails" placeholder="Correos"></autocomplete>
							                    <div class="text-danger" v-if="errors.emails">
					                            	{{ arrayText(errors.emails) }}
					                            </div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
		      		</div>
		      		<div class="modal-footer">
						<button type="button" class="btn btn-link text-white" style="background-color: rgba(0,0,0,0.5);" v-tooltip="'Guardar'" v-on:click="storeEvent()" :disabled="loading.store">
							<i class="material-icons">save</i> Guardar
						</button>
			      	</div>
		    	</div>
		 	</div>
		</div>

		<div class="fixed-action-btn" v-tooltip="'Agregar Evento'">
		    <a href="#" class="btn btn-primary btn-floating btn-large" data-toggle="modal" data-target="#modalEvent">
		        <i class="material-icons">add</i>
		    </a>
		</div>
	</div>
</template>
<script>
	export default {
		mounted() {
	    	this.getEvents();
	    	this.getOportunidades();
	    	this.closeModal();
	    	this.getEmails();
	    },

	    data(){
	    	return {
	    		events: [],
	    		oportunidades: [],
	    		forms: {
	    			title: '',
	    			oportunidad: '',
	    			tipo_tarea: '',
	    			fecha_inicial: '',
	    			fecha_final: '',
	    			notas: '',
	    			emails: []
	    		},
	    		emails: [],
	    		errors: [],
	    		loading: {
	    			emails: false,
	    			store: false,
	    		}
	    	}
	    },

	    methods: {
	    	getEvents: function(){
	    		var url = '/api/calendario';

	    		axios.get(url).then(response=>{
	    			this.events = response.data;
	    		}).catch(error=>{
	    			console.log(error.response);
	    		});
	    	},

	    	getOportunidades: function(){
	    		var url = '/api/oportunidades';

	    		axios.get(url).then(response=>{
	    			this.oportunidades = response.data;
	    		}).catch(error=>{
	    			console.log(error.response);
	    		});	
	    	},

	    	closeModal: function(){
	    		$('#modalEvent').hide("slow");
	    	},

	    	openModal: function(){
	    		$('#modalEvent').show("slow");
	    	},

	    	getEmails: function(){
	    		var url = '/api/emails';
	    		this.loading.emails = true;

	    		axios.get(url).then(response=>{
	    			this.emails = response.data;
	    		}).catch(error=>{
	    			console.log(error.response);
	    		}).then(()=>{
	    			this.loading.emails = false;
	    			this.getSerialize();
	    		});
	    	},

	    	storeEvent: function(){
	    		var url = '/calendario';
	    		this.loading.store = true;

	    		axios.post(url,{
	    			title: this.forms.title,
	    			oportunidad: this.forms.oportunidad,
	    			fecha_inicial: this.forms.fecha_inicial,
	    			fecha_final: this.forms.fecha_final,
	    			tipo_tarea: this.forms.tipo_tarea,
	    			notas: this.forms.notas,
	    			emails: this.forms.emails
	    		}).then(response=>{
	    			this.emails = response.data;
	    			toastr.success('El evento ha sido agregado.');
	    		}).catch(error =>{
	    			console.log(error.response);
	    			toastr.error('Existe un error');
	    			if (error.response.status == 422 & typeof(error.response.data.errors) != "undefined") {
                        this.errors = error.response.data.errors;
                    }
	    		}).then(()=>{
	    			this.loading.store = false;
	    			this.getSerialize();
	    		});
	    	},

	    	arrayText: function(text){
                text = text.toString().replace('["', '');
                text = text.toString().replace('"]"', '');

                return text;
            },
	    }
	}
</script>